/**
 * Created by ganlu on 20/01/2017.
 */
export default () => {
    return (scope, element) => {
        element.on('error', () => {
            scope.$apply(() => {
                scope.setImageUnavailable();
            });
        });
    };
};



// WEBPACK FOOTER //
// ./src/app/components/page/original/original-image/original-image-fallback.directive.js